import { Select } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';

import { Link, MAX_CONTENT_WIDTH } from 'modules/UI';

export const Container = styled.footer`
  font-family: ${tokens.fonts.primary};
  background: ${tokens.colors.white};
  width: 100%;
  display: flex;
  justify-content: center;
  border-top: 1px solid #dcdcdc66;
  padding: 0 ${tokens.space.regular};
  box-sizing: border-box;
`;

export const Bottom = styled.div`
  border-top: 1px solid ${tokens.colors.gray};
  padding-top: ${tokens.space.larger};
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Content = styled.div`
  max-width: ${MAX_CONTENT_WIDTH};
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
`;

type FooterLinkProps = {
  noMargin?: boolean;
};

export const FooterLink = styled(Link)<FooterLinkProps & SpaceProps>`
  font-family: ${tokens.fonts.secondary};
  font-size: ${tokens.fontSizes.s};
  line-height: ${tokens.lineHeights.m};
  color: ${tokens.colors.grayDarkest};
  margin-bottom: ${({ noMargin }): string => (noMargin ? '0' : tokens.space.regular)};

  ${space};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Copyright = styled.div`
  flex-shrink: 0;
  display: flex;
`;

export const CopyrightText = styled.span`
  max-width: 205px;
  display: inline-block;
  font-weight: 400;
  font-size: ${tokens.fontSizes.xs};
  line-height: ${tokens.lineHeights.s};
  color: ${tokens.colors.grayDarkest};
`;

export const Icon = styled.img`
  margin-right: ${tokens.space.regular};
`;

export const SelectLanguages = styled(Select)`
  width: fit-content;
  margin-left: auto;
  button {
    border: 0;
    padding-right: 0;
    &:focus-within {
      border: 0;
      box-shadow: 0 0 0 0;
    }
    > div {
      width: 32px;
    }
  }
  ${tokens.mediaQueries.s} {
    width: 100%;
    margin-left: inherit;
    margin-top: ${tokens.space.small};
  }
`;
